import { SectionKeys } from '@app/data/settings/settings';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface SelectedKeyState {
  selectedKey: SectionKeys;
}

const initialState: SelectedKeyState = {
  selectedKey: SectionKeys.my_profile,
};

export const selectedKeySlice = createSlice({
  name: 'selectedKey',
  initialState,
  reducers: {
    setSelectedKey: (state, action: PayloadAction<SectionKeys>) => {
      state.selectedKey = action.payload;
    },
    resetSelectedKey: (state) => {
      state.selectedKey = SectionKeys.my_profile;
    },
  },
});

export const {
  setSelectedKey,
  resetSelectedKey,
} = selectedKeySlice.actions;

export default selectedKeySlice.reducer;
